export default __webpack_public_path__ + "media/images/corporate/hero/lg-e00b3bce161d80256bb9c62dcc7ed0bf.png";